import { FORM_LABELS, FORM_OPTIONS } from '@/CONSTS'

export const self = {
  nickname: {
    label: FORM_LABELS.nickname,
    placeholder: '全角・半角英数字15文字以内',
    value: '',
    inputType: 'text',
    rules: { required: false, max: 15 }
  },
  gender: { label: FORM_LABELS.gender, value: '', inputType: 'radio', options: FORM_OPTIONS.gender },
  last_name: { label: FORM_LABELS.last_name, placeholder: '占井', value: '', inputType: 'text', rules: { required: true } },
  first_name: { label: FORM_LABELS.first_name, placeholder: '花子', value: '', inputType: 'text', rules: { required: true } },
  last_name_seimei: {
    label: FORM_LABELS.last_name,
    placeholder: '全角3文字以内',
    value: '',
    inputType: 'text',
    rules: { symbolCheck: true, alphabetCheck: true, halfKanaCheck: true, numberCheck: true, required: true }
  },
  first_name_seimei: {
    label: FORM_LABELS.first_name,
    placeholder: '全角3文字以内',
    value: '',
    inputType: 'text',
    rules: { symbolCheck: true, alphabetCheck: true, halfKanaCheck: true, numberCheck: true, required: true }
  },
  last_name_kana: { label: FORM_LABELS.last_name_kana, placeholder: 'うらない', value: '', inputType: 'text', rules: { required: true } },
  first_name_kana: { label: FORM_LABELS.first_name_kana, placeholder: 'はなこ', value: '', inputType: 'text', rules: { required: true } },
  birthday: {
    label: FORM_LABELS.birthday,
    placeholder: '2000 / 01 / 01',
    placeholderYear: '2000',
    placeholderMonth: '01',
    placeholderDay: '01',
    value: '',
    inputType: 'birthday',
    rules: { required: true, birthRange: true }
  },
  birthtime: {
    label: FORM_LABELS.birthtime,
    placeholder: '00 : 00',
    value: { value: '', unknown: '' },
    rules: { required: true, birthtimeFormat: true },
    inputType: 'birthtime',
    unknownName: 'birthtime_unknown'
  },
  blood: { label: FORM_LABELS.blood, value: '', inputType: 'select', rules: { required: true }, options: FORM_OPTIONS.blood },
  birthorder: {
    label: FORM_LABELS.birthorder,
    value: '',
    inputType: 'select',
    rules: { required: true },
    options: FORM_OPTIONS.birthorder
  },
  from_pref: { label: FORM_LABELS.from_pref, value: '', inputType: 'select', rules: { required: true }, options: FORM_OPTIONS.from_pref },
  job: {
    label: FORM_LABELS.job,
    value: '',
    placeholder: '不動産関係の会社で営業事務',
    inputType: 'text',
    rules: { required: true, max: 30 }
  },
  relationship: {
    label: FORM_LABELS.relationship,
    value: '',
    inputType: 'select',
    rules: { required: true, relationshipCheck: true },
    options: FORM_OPTIONS.relationship
  },
  picture1_url: { label: FORM_LABELS.picture1_url, value: '', inputType: 'file', rules: { required: true } },
  picture2_url: { label: FORM_LABELS.picture2_url, value: '', inputType: 'file', rules: { required: true } },
  picture3_url: { label: FORM_LABELS.picture3_url, value: '', inputType: 'file', rules: { required: true } },
  nonmember_email: {
    label: FORM_LABELS.email,
    placeholder: '半角英数字で入力してください',
    value: '',
    inputType: 'email',
    rules: {
      required: true,
      email: false,
      duplicateEmail: true,
      nonRfcEmailCheck: true
    }
  }
}

// 手相
export const palm = {
  palm: {
    name: 'palm',
    inputType: 'palm',
    storagePath: '', // 一時アップロード先のprefix
    fields: [
      {
        name: 'image_url_palm_left_overall',
        label: FORM_LABELS.image_url_palm_left_overall,
        shortLabel: FORM_LABELS.image_url_palm_left_overall_short,
        sendFlg: true
      },
      {
        name: 'image_url_palm_left',
        label: FORM_LABELS.image_url_palm_left,
        shortLabel: FORM_LABELS.image_url_palm_left_short,
        sendFlg: true
      },
      {
        name: 'image_url_palm_right_overall',
        label: FORM_LABELS.image_url_palm_right_overall,
        shortLabel: FORM_LABELS.image_url_palm_right_overall_short,
        sendFlg: true
      },
      {
        name: 'image_url_palm_right',
        label: FORM_LABELS.image_url_palm_right,
        shortLabel: FORM_LABELS.image_url_palm_right_short,
        sendFlg: true
      }
    ],
    values: {
      image_url_palm_left_overall: '',
      image_url_palm_left: '',
      image_url_palm_right_overall: '',
      image_url_palm_right: ''
    },
    rules: {
      required: true
    }
  }
}

export const target = {
  target_nickname: {
    label: FORM_LABELS.target_nickname,
    placeholder: '全角・半角英数字15文字以内',
    value: '',
    inputType: 'text',
    rules: {
      required: true,
      max: 15
    }
  },
  target_last_name: {
    label: FORM_LABELS.target_last_name,
    placeholder: '占井',
    value: '',
    inputType: 'text',
    rules: {
      required: true
    }
  },
  target_first_name: {
    label: FORM_LABELS.target_first_name,
    placeholder: '花子',
    value: '',
    inputType: 'text',
    rules: {
      required: true
    }
  },
  target_last_name_kana: {
    label: FORM_LABELS.target_last_name_kana,
    placeholder: 'うらない',
    value: '',
    inputType: 'text',
    rules: {
      required: true
    }
  },
  target_first_name_kana: {
    label: FORM_LABELS.target_first_name_kana,
    placeholder: 'はなこ',
    value: '',
    inputType: 'text',
    rules: {
      required: true
    }
  },
  target_birthday: {
    label: FORM_LABELS.target_birthday,
    value: '',
    inputType: 'birthday',
    rules: {
      required: true,
      birthRange: true
    }
  },
  target_birthtime: {
    label: FORM_LABELS.target_birthtime,
    placeholder: '',
    value: {
      value: '',
      unknown: ''
    },
    inputType: 'birthtime',
    unknownName: 'birthtime_unknown'
  },
  target_gender: {
    label: FORM_LABELS.target_gender,
    value: '',
    inputType: 'radio',
    options: FORM_OPTIONS.gender
  },
  target_blood: {
    label: FORM_LABELS.target_blood,
    value: '',
    inputType: 'select',
    rules: {
      required: true
    },
    options: FORM_OPTIONS.blood
  },
  target_birthorder: {
    label: FORM_LABELS.target_birthorder,
    value: '',
    inputType: 'select',
    rules: {
      required: true
    },
    options: FORM_OPTIONS.birthorder
  },
  target_from_pref: {
    label: FORM_LABELS.target_from_pref,
    value: '',
    inputType: 'select',
    rules: {
      required: true
    },
    options: FORM_OPTIONS.from_pref
  },
  target_job: {
    label: FORM_LABELS.target_job,
    value: '',
    placeholder: '不動産関係の会社で営業事務',
    inputType: 'text',
    rules: {
      required: true,
      max: 30
    }
  }
}

export const entry = {
  entry_genre: {
    label: FORM_LABELS.entry_genre,
    value: '',
    placeholder: '',
    inputType: 'select',
    rules: { required: true },
    options: FORM_OPTIONS.entry_genre
  },
  love_status: {
    label: FORM_LABELS.love_status,
    value: '',
    inputType: 'select',
    rules: { required: true },
    options: FORM_OPTIONS.love_status
  },
  connection_period: {
    label: FORM_LABELS.connection_period,
    value: '',
    inputType: 'select',
    rules: { required: true },
    options: FORM_OPTIONS.connection_period
  },
  romance_history: {
    label: FORM_LABELS.romance_history,
    value: '',
    inputType: 'select',
    rules: { required: true },
    options: FORM_OPTIONS.romance_history
  },
  lover_search_period: {
    label: FORM_LABELS.lover_search_period,
    value: '',
    inputType: 'select',
    rules: { required: true },
    options: FORM_OPTIONS.lover_search_period
  },
  entry_detail: {
    label: FORM_LABELS.entry_detail,
    value: '',
    placeholder: '',
    inputType: 'textarea',
    aside: '',
    rows: 5,
    rules: { required: true, max: 400 }
  },
  praise_detail: {
    label: FORM_LABELS.praise_detail,
    value: '',
    placeholder: '',
    inputType: 'textarea_option',
    aside: '',
    rows: 2,
    rules: { required: false, max: 400 }
  },
  has_partner: {
    label: FORM_LABELS.has_partner,
    value: '0',
    inputType: 'switch',
    rules: { required: true },
    options: FORM_OPTIONS.has_partner
  },
  partner_birthday: {
    label: FORM_LABELS.target_birthday,
    placeholder: '2000 / 01 / 01',
    placeholderYear: '2000',
    placeholderMonth: '01',
    placeholderDay: '01',
    value: '',
    inputType: 'birthday',
    rules: { required: true, birthRange: true }
  },
  metal_name: {
    label: FORM_LABELS.metal_name,
    value: '',
    placeholder: 'ローマ字で入力してください',
    inputType: 'text',
    rules: { required: true, max: 25, alpha: true }
  },
  neko_name: {
    label: FORM_LABELS.neko_name,
    value: '',
    placeholder: '全角・半角英数字15文字以内',
    inputType: 'text',
    rules: { required: true, max: 15, symbolCheck: true }
  },
  neko_theme: {
    label: FORM_LABELS.neko_theme,
    value: '',
    inputType: 'select',
    rules: { required: true },
    options: FORM_OPTIONS.neko_theme
  },
  licorice_name: {
    label: FORM_LABELS.licorice_name,
    value: '',
    placeholder: '全角・半角英数字6文字以内',
    inputType: 'text',
    rules: { required: true, max: 6, symbolCheck: true, halfKanaCheck: true }
  }
}

export const auth = {
  email: {
    label: FORM_LABELS.email,
    placeholder: 'メールアドレス',
    value: '',
    inputType: 'email',
    rules: {
      required: true,
      email: false,
      duplicateEmail: true,
      nonRfcEmailCheck: true
    }
  },
  password: {
    label: FORM_LABELS.password,
    placeholder: 'パスワード',
    value: '',
    inputType: 'password',
    rules: {
      required: true,
      max: 30,
      min: 8,
      passCheck1: true,
      passCheck2: true
    },
    strengMeter: true
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/CONSTS/FORM_DATA.js